import { useEffect, useState } from "react";
import axios from "axios";
export default function DeleteWebsite() {

  const [websites, setWebsites] = useState([]);
  const [msg, setMsg] = useState("");
const token = localStorage.getItem("token"); 

  //search 
  const [search, setSearch] = useState("");


  const loadWebsites = () => {
    axios
      .get(`/api/websites` , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => setWebsites(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    loadWebsites();
  }, []);

  const DeleteWebsite = (id) => {

    if (!window.confirm("Da li sigurno želiš da obrišeš sajt??")) return;

    axios
      .delete(`/api/websites/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(() => {
        setMsg("Sajt obrisan ✅");
        loadWebsites(); // refresh lista
      })
      .catch(() => setMsg("Greška pri brisanju ❌"));
  };


    // Filtrirana lista po search inputu
    const s = search.toLowerCase();

    const filteredWebsites = (websites || []).filter(w =>
      (w?.naziv || "").toLowerCase().includes(s) ||
      String(w?.sajtID || "").includes(search) ||
      String(w?.ref_num || "").includes(search) ||
      (w?.httpadresa || "").toLowerCase().includes(s) ||
      (w?.ime || "").toLowerCase().includes(s) ||
      (w?.email || "").toLowerCase().includes(s)
    );

  return (
    <div className="card bg-dark text-white p-4">
      <h4>Website delete</h4>

      {/* LOKALNI SEARCH */}
      <input
        type="text"
        className="form-control mb-3 w-25"
        placeholder="Search by ID or data..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />


      {msg && <p>{msg}</p>}
        <div className="table-responsive-lg position-relative">
            <table className="table table-dark-wh">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Naziv</th>
                    <th>HTTP</th>
                    <th>Reference</th>
                    <th>Sajt login</th>
                    <th>CPanel login</th>
                    <th>domen exp</th>
                    <th>hosting exp</th>
                    <th>odrzavanje</th>
                    <th>Klijent - ID</th>
                    <th>Klijent - Ime</th>
                    <th>Klijent - Email</th>
                    <th></th>
                </tr>
                </thead>

                <tbody>
                {filteredWebsites.map(w => (
                    <tr key={w.sajtID}>
                    <th>{w.sajtID}</th>
                    <th>{w.naziv}</th>
                    <th>{w.httpadresa}</th>
                    <th>{w.ref_num}</th>
                    <th>{w.sajt_akreditacija}</th>
                    <th>{w.cpanel_akreditacija}</th>
                    <th>{w.domen_expire}</th>
                    <th>{w.hosting_expire}</th>
                    <th>{w.odrzavanje}</th>
                    <th>{w.klijentID}</th>
                    <th>{w.ime}</th>
                    <th>{w.email}</th>
                    <td>
                        <button
                        className="btn btn-danger btn-sm"
                        onClick={() => DeleteWebsite(w.sajtID)}
                        >
                        Delete
                        </button>
                    </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    </div>
  );
}